/**
 * Enum for MediaType.
 * @readonly
 * @enum {{name: string }
 */
export const MediaType = Object.freeze({
	IMAGE: {name: 'IMAGE'},
	MOVIE: {name: 'MOVIE'},
});
